<template>
  <div v-if="resolvedUrl">
    <v-row>
      <v-col cols="auto" class="img-preview">
        <div class="img-overlay" :class="{'unknown-type' : formattedFileType === 'OTHER'}" @click="formattedFileType !== 'OTHER' ? previewImg() : null" :style="{height: boxSize + 'px', width: boxSize + 'px'}"></div>
        <v-img
          v-if="thumbnail || resolvedUrl"
          lazy-src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
          :src="thumbnailDisplay"
          :height="boxSize" :width="boxSize"
          :alt="alt">
        </v-img>
        <EsButtonIcon
          icon="mdi-download"
          @click="downloadFile()"
          download
          class="img-download-btn"
          dark />
      </v-col>
    </v-row>
    <v-dialog v-if="showPreview" v-model="showPreview" width="1200">
      <v-card class="pa-5">
        <div v-if="formattedFileType === 'PDF'">
          <EsAttachmentPreviewPdf :url="resolvedUrl" :fileName="alt" :ADOBE_KEY='ADOBE_KEY' />
        </div>
        <div v-else-if="formattedFileType === 'VIDEO'">
          <video width="1160" height="470" controls autoplay>
            <source :src="resolvedUrl" type="video/mp4">
          Your browser does not support the video tag.
          </video>
        </div>
        <v-img
          v-else
          contain :alt="alt"
          lazy-src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
          :src="resolvedUrl"></v-img>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import pdfThumbnail from '@/assets/pdf-thumbnail.png';
import videoThumbnail from '@/assets/video-thumbnail.png';
import unknownThumbnail from '@/assets/unknown-thumbnail.png';
import { EsButtonIcon } from "@86-repairs/design-system";
import EsAttachmentPreviewPdf from './EsAttachmentPreviewPdf.vue';

export default {
  name: 'EsAttachmentPreview',
  components: {
    EsButtonIcon,
    EsAttachmentPreviewPdf,
  },
  async beforeMount() {
    this.resolvedUrl = await this.getUrlFunc();
  },
  props: {
    getUrlFunc: {
      type: Function,
      required: true,
      default: () => {},
    },
    thumbnail: {
      type: String,
    },
    alt: {
      type: String,
      required: true,
    },
    fileType: {
      type: String,
      default: 'JPG',
    },
    ADOBE_KEY: {
      type: String,
      required: true,
    },
    boxSize: {
      type: Number,
      required: false,
      default: 100,
    },
  },
  data: () => ({
    showPreview: false,
    resolvedUrl: null,
    pdfThumbnail,
    videoThumbnail,
    unknownThumbnail,
  }),
  computed: {
    formattedFileType() {
      let type = this.fileType || this.resolvedUrl?.substring(this.resolvedUrl.lastIndexOf('.') + 1, this.resolvedUrl.length) || this.resolvedUrl;
      const queryIndex = type.indexOf('?');
      if (queryIndex > -1) {
        type = type?.substring(0, queryIndex) || type;
      }
      return type?.toUpperCase();
    },
    thumbnailDisplay() {
      if (this.formattedFileType === 'PDF') {
        return this.pdfThumbnail;
      } else if (this.formattedFileType === 'VIDEO') {
        return this.videoThumbnail;
      } else if (this.formattedFileType === 'OTHER') {
        return this.unknownThumbnail;
      } else {
        return this.thumbnail || this.resolvedUrl;
      }
    },
  },
  methods: {
    async previewImg() {
      this.resolvedUrl = await this.getUrlFunc();
      this.showPreview = true;
    },
    async downloadFile() {
      this.resolvedUrl = await this.getUrlFunc();
      window.open(this.resolvedUrl, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
  .pdf-iframe {
    width: 100%;
    height: 80vh !important;
  }
  .img-overlay {
    cursor: pointer;
    background: #333;
    position: absolute;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.4s;
    &.unknown-type {
      cursor: auto;
    }
  }
  .img-download-btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
    z-index: 2;
    opacity: 0;
    transition: opacity 0.4s;
  }
  .img-preview {
    position: relative;
    z-index: 0;
    &:hover {
      .img-overlay {
        opacity: 0.5;
      }
      .img-download-btn {
        opacity: 1;
      }
    }
  }
</style>